import { Column, CourtBooking, CourtBookingServer, CourtsBooking, CourtsBookingServer, ServerColumn, } from '../store/types';

function createEmptyColumn(courtId: number): Column[] {
  return ([{
    bookingId: null,
    userName: null,
    coachName: null,
    coachBookingId: undefined,
    bookingType: null,
    courtId,
    groupeName: null,
    courtName: 'empty',
    isBookingEnd: false,
    isBookingStart: false,
    confirmed: false,
    userBalance: '0',
    userHasDeposit: null
  }]);
}

function adapteCourtBookingColumns(columns: ServerColumn[], prevColumns?: ServerColumn[], nextColumns?: ServerColumn[]): Column[][] {
  const filteredColumns: Record<number, Column[]> = {};
  columns.forEach((column) => {
    const selectedColumn = filteredColumns[column.court_id];
    if (selectedColumn === undefined) {
      filteredColumns[column.court_id] = [];
    }
    filteredColumns[column.court_id].push({
      courtId: column.court_id,
      bookingType: column.booking_type,
      bookingId: column.booking_id,
      courtName: column.court_name,
      coachBookingId: column.coach_booking_id,
      note: column.note,
      userName: column.user_role === 'user' ? column.user_name : null,
      groupeName: column.user_role === 'group' ? column.user_name : null,
      coachName: column.coach_name,
      confirmed: column.confirmed,
      userBalance: Number(column.user_balance).toFixed(0),
      userHasDeposit: column.user_has_deposit,
      isBookingEnd: nextColumns === undefined
        ? column.booking_id !== null
        : !nextColumns.some((nextColumn) => (
          nextColumn.booking_id === column.booking_id)
        ),
      isBookingStart: prevColumns !== undefined
        ? !prevColumns.some((prevColumn) => (
          prevColumn.booking_id === column.booking_id))
        : column.booking_id !== null
    });
  });

  return (Object.values(filteredColumns));
}


export const adaptCourtsBooking = (res: CourtsBookingServer): CourtsBooking => {
  const courtsBooking: CourtsBooking = [];

  res.forEach((row, index) => {
    const currentColumns = res[index].columns;
    const nextColumns = res[index + 1]?.columns;
    const prevColumns = res[index - 1]?.columns;

    courtsBooking.push({
      startTime: row.start_time,
      columns: adapteCourtBookingColumns(currentColumns, prevColumns, nextColumns)
    });
  });

  courtsBooking.unshift({
    startTime: '0000-00-00T00:00:00',
    columns: courtsBooking[0].columns.map((column) => createEmptyColumn(column[0].courtId))
  });

  return (courtsBooking);
};

export const adaptCourtBooking = (booking: CourtBookingServer): CourtBooking => ({
  id: booking.id,
  startTime: booking.start_time,
  endTime: booking.end_time,
  courtId: booking.court_id,
  created: booking.created,
  coachNames: [booking.coach_name],
  userIds: [booking.user_role === 'user' ? booking.user_id : null],
  groupeId: booking.user_role === 'group' ? booking.user_id : null,
  userNames: [booking.user_role === 'user' ? booking.user_name : null],
  groupeName: booking.user_role === 'group' ? booking.user_name : null,
  type: booking.type,
  coachBookingIds: [booking.coach_booking_id],
  price: [Number(booking.price)],
  priceDetails: [{
    courtTotal: Number(booking.price_details.court_total),
    coachTotal: Number(booking.price_details.coach_total),
    userName: booking.user_name,
    extraOptionsTotal: Number(booking.price_details.extra_options_total),
    extraOptions: booking.price_details.extra_options,
  }],
  usersHasDeposite: [booking.user_has_deposit],
  note: booking.note,
  confirmed: booking.confirmed
});
